export enum Language {
    SANSKRIT = 'sa',
    ENGLISH = 'en',
    HINDI = 'hi',
    KANNADA = 'kn',
    TAMIL = 'ta',
    TELUGU = 'te',
    MALAYALAM = 'ma'
}

export interface Transliteration {
    id: number;
    language: Language;
    text: string;
    sutra_id: number;
} 